import type {
	LoginAuthOpened,
	LoginModalOpened,
	SignUpCompleted,
	TermsClicked,
	TokenResendClicked
} from '~/types/mixpanel';
import type { Dict } from 'mixpanel-browser';

import { MixpanelEvents } from '~/core/service/mixpanel';
import { safeTrack } from '~~/utils';

export const useTrackSignAndLogin = () => {
	const trackLoginOpened = (params: LoginModalOpened) => {
		safeTrack(MixpanelEvents.LOGIN_OPENED, params);
	};

	const trackLoginPhone = (params: LoginAuthOpened) => {
		safeTrack(MixpanelEvents.LOGIN_PHONE, params);
	};

	const trackingLoginAuthentication = (params: LoginAuthOpened) => {
		safeTrack(MixpanelEvents.LOGIN_AUTHENTICATION, params);
	};

	const trackingTermsOrpolicy = (params: TermsClicked) => {
		safeTrack(MixpanelEvents.THERMS_CLICKED, params);
	};

	const trackingSignupCompleted = (params: SignUpCompleted) => {
		safeTrack(MixpanelEvents.SIGNUP_COMPLETED, params);
	};

	const tokenResendClick = (params: TokenResendClicked) => {
		safeTrack(MixpanelEvents.TOKEN_RESEND_CLICK, params);
	};

	return {
		trackLoginOpened,
		trackLoginPhone,
		trackingLoginAuthentication,
		trackingTermsOrpolicy,
		trackingSignupCompleted,
		tokenResendClick
	};
};
